import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=39af0330&"
import script from "./Employees.vue?vue&type=script&lang=ts&"
export * from "./Employees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports